var map = {
	"./az/resources-1920.jpg": "ce25",
	"./be/resources-1920.jpg": "4e90",
	"./en/resources-1920.jpg": "28cd",
	"./et/resources-1920.jpg": "0e1e",
	"./hy/resources-1920.jpg": "f26b",
	"./ka/resources-1920.jpg": "b658",
	"./kk/resources-1920.jpg": "c32e",
	"./ky/resources-1920.jpg": "6810",
	"./lt/resources-1920.jpg": "fb37",
	"./lv/resources-1920.jpg": "c127",
	"./mn/resources-1920.jpg": "2290",
	"./ru/resources-1920.jpg": "4a19",
	"./uz/resources-1920.jpg": "10c7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5a00";